<template lang="html">
  <div class="fill-height">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      dark
      color="#19212b"
    >
      <v-list
        dense
        nav
      >
        <template v-for="link in links">
          <v-divider
            v-if="link.type === 'divider'"
            :key="link.id"
          />
          <v-subheader
            v-if="link.type === 'subheader'"
            :key="link.id"
            class="text-truncate"
          >
            {{ link.text }}
          </v-subheader>
          <v-list-group
            v-if="link.items && link.type === 'link'"
            :key="link.to"
            :value="$route.params.page === link.id"
            no-action
            active-class="teal--text text--accent-2"
            :append-icon="link.expanded ? '' : $vuetify.icons.expand"
          >
            <template #activator>
              <v-list-item-icon>
                <v-icon v-if="!link.expanded">
                  {{ link.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content
                active-class="teal--text text--accent-2"
                class="si-action-show-overflow"
              >
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="(item, i) in link.items">
              <v-list-item 
                :key="i" 
                :to="item.type === 'link' ? `${link.to}/${item.id}` : undefined" 
                active-class="teal--text text--accent-2"
                @click="() => item.callback ? item.callback() : () => {}"
              >
                <v-list-item-title v-if="item.type === 'action'">
                  <v-layout
                    align-center
                    ma-0
                    class="grey--text"
                  >
                    <v-icon
                      color="grey"
                      left
                    >
                      {{ item.icon }}
                    </v-icon>
                    {{ item.text }}
                  </v-layout>
                </v-list-item-title>
                <v-list-item-title v-else>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list-group>

          <v-list-item
            v-if="!link.items && link.type === 'link'"
            :key="link.to"
            :to="link.to"
            active-class="teal--text text--accent-2"
          >
            <v-list-item-action>
              <v-badge
                right
                :color="link.badgeColor || 'info'"
                :value="link.badge > 0 && showBadges"
              >
                <template #badge>
                  <span>{{ link.badge }}</span>
                </template>
                <v-icon :color="link.badge > 0 && link.badgeColor ? link.badgeColor : ''">
                  {{ link.icon }}
                </v-icon>
              </v-badge>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ link.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="link.type === 'action'">
            <v-list-item
              :key="link.id"
              @click="link.callback"
            >
              <v-list-item-title>
                <v-layout
                  align-center
                  ma-0
                  class="grey--text"
                >
                  <v-icon
                    color="grey"
                    left
                  >
                    {{ link.icon }}
                  </v-icon>
                  {{ link.text }}
                </v-layout>
              </v-list-item-title>
            </v-list-item>
          </template>
        </template>
        <div
          class="si-version grey--text"
          :class="{'warning--text font-weight-bold': isOldVersion}"
        >
          <v-icon
            v-if="isOldVersion"
            color="warning"
          >
            warning
          </v-icon>
          Version: {{ version }}
          <span v-if="isOldVersion"> | {{ systemVersionText }}</span>
        </div>
      </v-list>
    </v-navigation-drawer>

    <SiNewCalculator v-model="newCalculator" />
    <!-- <router-view></router-view> -->
    <Dashboard v-if="$route.name === 'console' && $route.params.page === 'dashboard'" />
    <Assistance v-if="$route.name === 'console' && $route.params.page === 'assistance'" />
    <Consulting v-if="$route.name === 'console' && $route.params.page === 'consulting'" />
    <Contact v-if="$route.name === 'console' && $route.params.page === 'contact'" />
    <Bulletin v-if="$route.name === 'console' && $route.params.page === 'bulletin'" />
    <Calculators v-if="$route.name === 'console' && $route.params.page === 'calculations'" />
    <ClientPath v-if="$route.name === 'console' && $route.params.page === 'clientpath'" />
    <Feedback v-if="$route.name === 'console' && $route.params.page === 'feedback'" />
    <Suggestions v-if="$route.name === 'console' && $route.params.page === 'suggestions'" />
    <UserProfile v-if="$route.name === 'console' && $route.params.page === 'user'" />
    <Accounting v-if="$route.name === 'console' && $route.params.page === 'accounting'" />

    <AdminAssistance v-if="$route.name === 'admin' && $route.params.sub === 'assistance'" />
    <AdminCalculators v-if="$route.name === 'admin' && $route.params.page === 'calculators'" />
    <AdminClientPath v-if="$route.name === 'admin' && $route.params.sub === 'clientpath'" />
    <AdminConsulting v-if="$route.name === 'admin' && $route.params.sub === 'consulting'" />
    <AdminInvoicing v-if="$route.name === 'admin' && $route.params.sub === 'invoicing'" />
    <AdminLegal v-if="$route.name === 'admin' && $route.params.sub === 'legal'" />
    <AdminLogs v-if="$route.name === 'admin' && $route.params.page === 'logs'" />
    <AdminMessaging v-if="$route.name === 'admin' && $route.params.sub === 'messaging'" />
    <AdminTestimonials v-if="$route.name === 'admin' && $route.params.sub === 'testimonials'" />
  
    <v-snackbar
      :value="isOldVersion"
      :timeout="-1"
      color="warning"
    >
      A new version of Super Info console is availabe.
      <template #action>
        <v-btn
          text
          dark
          @click="reload"
        >
          Reload
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import messagintInit from '@/mixins/messaging-init'
import binder from '@/mixins/binder'
import version from '@/version.json'
import Consulting from './consulting/Consulting'
import AdminConsulting from './admin/consulting/Consulting'
import AdminCalculators from './admin/calculators/Calculators'
import AdminAssistance from './admin/assistance/Assistance'
import Accounting from './admin/accounting/Accounting'
import AdminClientPath from './admin/clientpath/ClientPath'
import AdminInvoicing from './admin/invoicing/Invoicing'
import AdminLogs from './admin/logs/Logs'
import AdminMessaging from './admin/messaging/Messaging'
import AdminLegal from './admin/legal/Legal'
import AdminTestimonials from './admin/testimonials/Testimonials'
    
export default {
  components: {
    Consulting,
    AdminConsulting,
    AdminCalculators,
    AdminAssistance,
    Accounting,
    AdminClientPath,
    AdminInvoicing,
    AdminLogs,
    AdminMessaging,
    AdminLegal,
    AdminTestimonials,
  },
  mixins: [ messagintInit, binder ],
  data () {
    return {
      drawer: this._drawer,
      newCalculator: false,
      showBadges: false,
      messagingMessage: null,
      systemVerion: {}
    }
  },
  computed: {
    ...mapGetters(['_drawer', '_userInfo', '_badgeTotals', '_calculators']),
    calulatorLinks () {
      var links = []
      forEach(this._calculators, (c, id) => {
        links.push({
          text: c.name || c.id,
          id: id,
          type: 'link',
          to: `/calculations/${id}`,
          icon: 'assessment',
          badge: this.badge(id)
        })
      })
      return links
    },
    links () {
      return [
        {
          text: 'Dashboard',
          type: 'link',
          to: '/dashboard',
          id: 'home',
          badge: '',
          icon: 'dashboard'
        },
        {
          text: 'Assistance',
          type: 'link',
          to: '/assistance',
          id: 'assistance',
          badge: this.badge('assistance'),
          icon: 'support_agent'
        },
        {
          text: 'Consulting',
          type: 'link',
          to: '/consulting',
          id: 'consulting',
          badge: this.badge('consulting'),
          icon: 'event'
        },
        {
          text: 'Contact',
          type: 'link',
          to: '/contact',
          id: 'contact',
          badge: this.badge('contact'),
          icon: 'email'
        },
        {
          text: 'Bulletin',
          type: 'link',
          to: '/bulletin',
          id: 'bulletin',
          badge: this.badge('bulletin'),
          icon: 'auto_stories'
        },
        // { type: 'divider' },
        // { type: 'subheader', text: 'Insights' },
        // {
        //   text: 'Client Path',
        //   type: 'link',
        //   to: '/clientpath',
        //   id: 'clientpath',
        //   icon: 'track_changes'
        // },
        // {
        //   text: 'Feedback & Ratings',
        //   type: 'link',
        //   to: '/feedback',
        //   id: 'feedback',
        //   badge: this.badge('feedback'),
        //   icon: 'star'
        // },
        // {
        //   text: 'Tool Suggestions',
        //   type: 'link',
        //   to: '/suggestions',
        //   id: 'suggestions',
        //   badge: this.badge('suggestions'),
        //   icon: 'loupe'
        // },
        { type: 'divider' },
        { type: 'subheader', text: 'Calculators' },
        ...this.calulatorLinks,
        { type: 'divider' },
        { type: 'subheader', text: 'Admin' },

        {
          text: 'Insights',
          type: 'link',
          id: 'insights',
          to: '',
          icon: 'insights',
          items: [
            {
              id: 'accounting',
              text: 'Accounting',
              type: 'link'
            },
            {
              text: 'Client Path',
              type: 'link',
              to: '/clientpath',
              id: 'clientpath',
              icon: 'track_changes'
            },
            {
              text: 'Feedback & Ratings',
              type: 'link',
              to: '/feedback',
              id: 'feedback',
              badge: this.badge('feedback'),
              icon: 'star'
            },
            {
              text: 'Tool Suggestions',
              type: 'link',
              to: '/suggestions',
              id: 'suggestions',
              badge: this.badge('suggestions'),
              icon: 'loupe'
            },
          ]
        },
        {
          text: 'Calculators',
          type: 'link',
          id: 'calculators',
          to: '/admin/calculators',
          icon: 'assessment',
          items: [
            ...this.calulatorLinks,
            ...[{
              id: 'newCalculator',
              text: 'New Calculator',
              icon: 'add',
              type: 'action',
              callback: () => { this.newCalculator = true; console.log('is action'); }
            }]
          ]
        },
        {
          text: 'Settings',
          type: 'link',
          id: 'settings',
          to: '/admin/settings',
          icon: 'settings',
          items: [
            {
              id: 'assistance',
              text: 'Assistance',
              type: 'link'
            },
            {
              id: 'clientpath',
              text: 'Client Path Mapping',
              type: 'link'
            },
            {
              id: 'consulting',
              text: 'Consulting',
              type: 'link'
            },
            {
              id: 'invoicing',
              text: 'Invoicing',
              type: 'link'
            },
            {
              id: 'legal',
              text: 'Legals',
              type: 'link'
            },
            {
              id: 'messaging',
              text: 'Messaging',
              type: 'link'
            },
            {
              id: 'testimonials',
              text: 'Testimonials',
              type: 'link'
            },
          ]
        },
        {
          text: 'Logs',
          type: 'link',
          to: '/admin/logs',
          id: 'logs',
          badge: this.badge('errors'),
          badgeColor: 'error',
          icon: 'chrome_reader_mode'
        }
        // {
        //   text: 'Migration',
        //   type: 'link',
        //   to: '/admin/migration',
        //   id: 'migration',
        //   icon: 'system_update'
        // },
      ]
    },
    version () {
      let { major, minor, build } = version
      return `${major}.${minor}.${build}`
    },
    systemVersionText () {
      let { major, minor, build } = this.systemVerion
      return `${major}.${minor}.${build}`
    },
    isOldVersion () {
      const number = (version = {}) => {
        let { major, minor, build } = version
        return Number(`${major}${minor}${build}`) || 0
      }
      return number(this.systemVerion) > number(version)
    }
  },
  watch: {
    _drawer (v) {
      this.drawer = v
    },
    drawer (v) {
      this.$store.commit('set_drawer', v)
    }
  },
  beforeMount () {
    if (!this.$route.params.page) this.$router.replace(this.links[0].to)
  },
  mounted () {
    const callback = (v) => {
      this.$store.commit('set_badgeTotals', v)
      setTimeout(() => { this.showBadges = true }, 500)
    }
    this.$bindRtdb('badging', 'badging', { callback })
    this.$bindRtdb('systemVerion', 'version')
    // this.$bindxxx(rtdb.ref('badging'), v => {
    //   this.$store.commit('set_badgeTotals', v)
    //   setTimeout(() => { this.showBadges = true }, 500)
    // })
    // this.$bindxxx(rtdb.ref('version'), 'systemVerion')

  },
  methods: {
    badge (key) {
      let badgeTotal = this._badgeTotals[key] || 0
      let userTotal = ((this._userInfo.seen || {})[key] || {}).total || 0
      return badgeTotal - userTotal
    },
    reload () {
      location.reload(true)
    }
  }
}
</script>

<style lang="css" scoped>
.si-version {
  text-align: center;
  font-size: 12px;
}
.si-action-badge {
  min-width: 26px;
}
.si-action-show-overflow {
  overflow: visible !important;
}

</style>
